import moment from 'moment';

const CHIP_LABEL_EXCESS = 18;

export function getDateIntervalsForCallingStatus(
  periodQuantity: number,
  periodDetails: 'days' | 'weeks' | 'months' | 'years'
) {
  const endDate = moment().toDate();
  endDate.setHours(0, 0, 0, 0);
  const startDate = moment().subtract(periodQuantity, periodDetails).toDate();
  startDate.setHours(0, 0, 0, 0);
  return [startDate, endDate] as Date[];
}

export function createChipTooltip(title: string, startDate: string) {
  return `${title} [${startDate}]`;
}

export function createChipLabelText(
  title: string,
  startDate: string,
  chipLabelExcess = CHIP_LABEL_EXCESS
) {
  return title.length > chipLabelExcess
    ? `${title.substring(0, chipLabelExcess).trim()}… [${startDate.split(' ')[0]}]`
    : `${title}[${startDate.split(' ')[0]}]`;
}
